import React, { Component } from 'react';
import { string, shape, number, func } from 'prop-types';
import i18next from 'i18next';

import { DISPATCH_METHODS } from '~constants/address';
import FormWrapper from '~components/FormWrapper';
import InputLabel from '~components/InputLabel';
import Field from '~components/Field';
import ErrorImage from '~components/ErrorContainer';
import { ERROR_IMAGES } from '~components/ErrorContainer/constants';
import { googleAddressPropTypes } from '~propTypes/address';

import { FIELDS } from './constants';
import styles from './styles.module.scss';
import StoreInfo from './components/StoreInfo';
import { validationSchema } from './utils';

class Delivery extends Component {
  handleSubmit = (values) => {
    const { onConfirm, deliveryInfo } = this.props;

    onConfirm({
      store: deliveryInfo,
      addressDetails: values,
      type: DISPATCH_METHODS.DELIVERY
    });
  };

  render() {
    const { className, deliveryInfo, error, selectedAddress } = this.props;

    // eslint-disable-next-line no-nested-ternary
    return error ? (
      <ErrorImage
        className="item-1 full-width"
        img={ERROR_IMAGES.NO_DELIVERY}
        title={i18next.t('Delivery:exclusionZone')}
        message={i18next.t('Delivery:exclusionZoneMessage')}
      />
    ) : selectedAddress?.hasStreetNumber ? (
      <FormWrapper
        onSubmit={this.handleSubmit}
        initialValues={selectedAddress}
        validationSchema={validationSchema}
        validateOnBlur
        avoidErrorUntilSubmit>
        {({ isSubmitting, handleSubmit }) => (
          <form className={`column full-width ${styles.deliveryForm}`} onSubmit={handleSubmit}>
            <div className={`full-width ${className}`}>
              <div className="m-bottom-4">
                <StoreInfo deliveryInfo={deliveryInfo} selectedAddress={selectedAddress} />
              </div>
              <div className="m-bottom-6 column full-width">
                <Field
                  name={FIELDS.APARTMENT}
                  component={InputLabel}
                  inputType="text"
                  className="item-1 m-bottom-4"
                  label={i18next.t('Delivery:apartmentPlaceholder')}
                />
                <Field
                  name={FIELDS.NOTE}
                  component={InputLabel}
                  isTextarea
                  inputType="textarea"
                  className="item-1 m-bottom-4"
                  label={i18next.t('Delivery:notePlaceholder')}
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              className={`button primary full-width ${styles.confirmButton}`}>
              {isSubmitting && <span className="material-icons-outlined  m-right-1 m-left-1">loop </span>}
              {i18next.t('Delivery:confirmButton')}
            </button>
          </form>
        )}
      </FormWrapper>
    ) : (
      <div className="row full-width center">
        <ErrorImage
          className={`item-1 full-width ${styles.noDeliveryError}`}
          img={ERROR_IMAGES.NO_DELIVERY}
          title={i18next.t('Delivery:notEnoughData')}
          message={i18next.t('Delivery:noStreetAddress')}
        />
      </div>
    );
  }
}

Delivery.propTypes = {
  onConfirm: func.isRequired,
  className: string,
  deliveryInfo: shape({
    name: string,
    deliveryWaitTime: number,
    menuId: number
  }),
  error: string,
  selectedAddress: googleAddressPropTypes
};

export default Delivery;
